exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".EndOfStory{line-height:0}.EndOfStory,.EndOfStory__inner{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100%;font-family:Roboto,sans-serif}.EndOfStory__inner{margin-top:20px;text-align:center;padding:40px 0;max-width:700px;margin:0 auto;letter-spacing:.5px;line-height:24px;font-size:16px;color:#393939;font-size:14px;line-height:19px}@media (max-width:740px){.EndOfStory__inner{margin-left:20px;margin-right:20px}}@media (max-height:600px),(max-width:649px){.EndOfStory__inner{font-size:12px;line-height:17px}}@media (min-width:900px){.EndOfStory__inner{font-size:14px}}.EndOfStory__inner a{margin-top:20px}.EndOfStory__inner a:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/components/DetailPage/EndOfStory/EndOfStory.scss
// module id = 283
// module chunks = 0